import axios from '../utils/axios';

export const getUserMediaContent = () => {
  return axios.get('multimediaapi/adminengine/v1/getusermediacontent').then(response => response.data);
}

// TODO change api request type to PUT
export const changMultimediaTag = (tag, id) => {
  return axios.get(`projects/multimedia/${id}/tag/${tag}`).then(response => response.data);
}